import { Layout, Typography, Row, Col } from "antd";
import { Link } from "react-router-dom";
import { useState } from "react";
import LogoHeader from "../components/LogoHeader";
import HeroSection from "../components/HeroSection";
import SearchSection from "../components/SearchSection";
import { CustomFooter } from "../components/Footer";
import RequestAccessModal from "../components/RequestAccessModal";
import ComplianceProgramCard from "../components/ComplianceProgramCard";
import ControlCard from "../components/ControlCard";
import SubprocessorCard from "../components/SubprocessorCard";
import DeliverableCard from "../components/DeliverableCard";
import { useMultiSearch } from "../hooks/useSearch.ts";

import complianceProgramsData from "../data/compliancePrograms.json";
import controlsData from "../data/controls.json";
import subprocessorsData from "../data/subprocessors.json";
import deliverablesData from "../data/deliverables.json";

const { Content } = Layout;
const { Title, Paragraph } = Typography;

export default function HomePage() {
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [modalContext, setModalContext] = useState({
    accessType: "full",
    deliverableName: null,
  });

  const showModal = (context) => {
    setModalContext(
      context && context.deliverableName
        ? { accessType: "deliverable", deliverableName: context.deliverableName }
        : { accessType: "full", deliverableName: null }
    );
    setIsModalVisible(true);
  };

  const handleModalCancel = () => {
    setIsModalVisible(false);
  };

  const allControls = [
    ...controlsData.fedramp20x,
    ...controlsData.fedrampRev5,
  ];
  const allSubprocessors = [
    ...subprocessorsData.leveragedSystems,
    ...subprocessorsData.interconnections,
  ];

  const { searchTerm, searchResults, onSearch } = useMultiSearch(
    complianceProgramsData,
    allControls,
    allSubprocessors,
    deliverablesData
  );

  const compliancePrograms = complianceProgramsData.slice(0, 3);
  const totalCompliancePrograms = complianceProgramsData.length;
  const totalDeliverables = deliverablesData.length;
  const deliverables = deliverablesData.slice(0, 3);

  return (
    <Layout style={{ minHeight: "100vh", margin: 0, padding: 0 }}>
      <LogoHeader />

      <Content style={{ padding: "48px 0", backgroundColor: "#fff" }}>
        <div
          style={{ maxWidth: "1200px", margin: "0 auto", padding: "0 24px" }}
        >
          <HeroSection
            title="Trust Center"
            onRequestAccess={showModal}
            onSearch={onSearch}
          />
          {searchTerm ? (
            <SearchSection
              searchTerm={searchTerm}
              searchSelection="Trust Center"
              totalResults={
                searchResults.compliancePrograms.length +
                searchResults.controls.length +
                searchResults.subprocessors.length +
                searchResults.deliverables.length
              }
            >
              {searchResults.compliancePrograms.map((program, index) => (
                <Col xs={24} md={8} key={`compliance-${index}`}>
                  <ComplianceProgramCard program={program} />
                </Col>
              ))}

              {searchResults.controls.map((control, index) => (
                <Col xs={24} md={8} key={`control-${index}`}>
                  <ControlCard control={control} />
                </Col>
              ))}

              {searchResults.subprocessors.map((subprocessor, index) => (
                <Col xs={24} md={8} key={`subprocessor-${index}`}>
                  <SubprocessorCard subprocessor={subprocessor} />
                </Col>
              ))}

              {searchResults.deliverables.map((deliverable, index) => (
                <Col xs={24} md={8} key={`deliverable-${index}`}>
                  <DeliverableCard
                    deliverable={deliverable}
                    onRequestAccess={(d) => showModal(d ? { deliverableName: d.title } : null)}
                  />
                </Col>
              ))}
            </SearchSection>
          ) : (
            <>
              <section id="compliance" style={{ marginBottom: "24px" }}>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    marginBottom: "8px",
                  }}
                >
                  <Title level={2}>Compliance Programs</Title>
                  <Link
                    to="/compliance-programs"
                    style={{
                      fontWeight: 400,
                      color: "#1467FF",
                      textDecoration: "none",
                    }}
                  >
                    See All ({totalCompliancePrograms})
                  </Link>
                </div>
                <Paragraph style={{ color: "#666", marginBottom: "24px" }}>
                  The ongoing systems pWin maintains to stay secure and
                  prove it—covering the policies, processes, and tools that
                  ensure regulatory and security requirements are consistently
                  met.
                </Paragraph>

                <Row gutter={[24, 24]}>
                  {compliancePrograms.map((program, index) => (
                    <Col xs={24} md={8} key={index}>
                      <ComplianceProgramCard program={program} />
                    </Col>
                  ))}
                </Row>
              </section>

              {/* <section id="controls" style={{ marginBottom: "24px" }}>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    marginBottom: "8px",
                  }}
                >
                  <Title level={2}>Controls</Title>
                  <Link
                    to="/controls"
                    style={{
                      fontWeight: 400,
                      color: "#1467FF",
                      textDecoration: "none",
                    }}
                  >
                    See All ({totalControls})
                  </Link>
                </div>
                <Paragraph style={{ color: "#666", marginBottom: "24px" }}>
                  Controls are the specific safeguards or security requirements
                  put in place to reduce risk and protect systems, data, and
                  operations.
                </Paragraph>

                <Row gutter={[24, 24]}>
                  {controls.map((control, index) => (
                    <Col xs={24} md={8} key={index}>
                      <ControlCard control={control} />
                    </Col>
                  ))}
                </Row>
              </section> */}

              {/* <section id="subprocessors" style={{ marginBottom: "24px" }}>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    marginBottom: "8px",
                  }}
                >
                  <Title level={2}>Subprocessors</Title>
                  <Link
                    to="/subprocessors"
                    style={{
                      fontWeight: 400,
                      color: "#1467FF",
                      textDecoration: "none",
                    }}
                  >
                    See All ({totalSubprocessors})
                  </Link>
                </div>
                <Paragraph style={{ color: "#666", marginBottom: "24px" }}>
                  Subprocessors are third-party service providers Paramify
                  relies on to deliver its product, and that may process, store,
                  or transmit customer data on its behalf.
                </Paragraph>

                <Row gutter={[24, 24]}>
                  {subprocessors.map((subprocessor, index) => (
                    <Col xs={24} md={8} key={index}>
                      <SubprocessorCard subprocessor={subprocessor} />
                    </Col>
                  ))}
                </Row>
              </section> */}

              <section id="deliverables" style={{ marginBottom: "24px" }}>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    marginBottom: "8px",
                  }}
                >
                  <Title level={2}>Deliverables</Title>
                  <Link
                    to="/deliverables"
                    style={{
                      fontWeight: 400,
                      color: "#1467FF",
                      textDecoration: "none",
                    }}
                  >
                    See All ({totalDeliverables})
                  </Link>
                </div>
                <Paragraph style={{ color: "#666", marginBottom: "24px" }}>
                  The evidence packages that demonstrate pWin has d
                  implemented required controls and is maintaining compliance.
                </Paragraph>

                <Row gutter={[24, 24]}>
                  {deliverables.map((deliverable, index) => (
                    <Col xs={24} md={8} key={index}>
                      <DeliverableCard
                        deliverable={deliverable}
                        onRequestAccess={(d) => showModal(d ? { deliverableName: d.title } : null)}
                      />
                    </Col>
                  ))}
                </Row>
              </section>
            </>
          )}
        </div>
      </Content>

      <CustomFooter />

      <RequestAccessModal
        visible={isModalVisible}
        onCancel={handleModalCancel}
        accessType={modalContext.accessType}
        deliverableName={modalContext.deliverableName}
      />
    </Layout>
  );
}
